import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import CTAButton from "../CTAButton";
import SlButton from "../SlButton/SlButton";

import css from "./Homepage.scss";


/* eslint-disable react/forbid-prop-types */

const HomepageCallToAction = ({
  href,
  title,
  description,
  buttonText,
  manualLink = false,
  className = ""
}) => {
  return (
    <div className={[css.homepageCallToAction, className || ""].join(" ")}>
      <h2 className={[css.ctaTitle, css.homepageCallToAction].join(" ")}>
        {!manualLink && <Link to={href}>{title}</Link>}
        {manualLink && <a href={href}>{title}</a>}
      </h2>
      <div className={css.ctaDescription}>
        <p>{description}</p>
      </div>


        <SlButton
          href={href}
          target="_self"
          variant="primary"
          icon="arrowRight"
          size="large"
          manualLink={manualLink}
          iconPosition="right"
          iconColor="#FE9B7C"
        >
          {buttonText}
        </SlButton>

      </div>

  );
};

HomepageCallToAction.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  manualLink: PropTypes.bool,
  className: PropTypes.string
};

HomepageCallToAction.defaultProps = {
  manualLink: false,
  className: ""
};

const Homepage = ({ className = "" }) => {
  return (
    <div className={className || ""}>
      <div className={css.gridContainer}>
          <div className={css.featured_section}>
            <div className={css.banner_section }>
              <h1 className={css.heading1}>Gallery guides and podcasts</h1>
            </div>
          </div>


        <div className={css.homepage_second_section}>
          <div className={ css.leftCol}>
            <HomepageCallToAction
                href="/gallery-guides"
                title="Gallery guides"
                description="View our guides with extended captions and images on your own device when visiting the galleries. Some of the items are accompanied by an audio guide."
                buttonText="See all guides"
                manualLink
            />
          </div>

          <div className={css.rightCol}>
            <HomepageCallToAction
                href="/podcasts"
                title="Podcasts"
                description="Listen to podcasts produced by the Library."
                buttonText="See all podcasts"
                manualLink
            />

        </div>
      </div>


      </div>




      </div>


  );
};

Homepage.propTypes = {
  className: PropTypes.string
};

Homepage.defaultProps = {
  className: ""
};

export default Homepage;
